import { reactive } from 'vue';
import { accountAttentionEnabled } from './capabilities';

export const attentionState = reactive({ snapshot: null, listRecovery: null });
export const attentionFor = id => {
  const routeAccount = Number(window.location.pathname.match(/\/app\/accounts\/(\d+)\//)?.[1]);
  if (routeAccount && attentionState.snapshot?.account_id !== routeAccount) return undefined;
  return attentionState.snapshot?.items?.find(item => item.conversation_id === Number(id));
};
export const attentionEnabled = (accountId = Number(window.location.pathname.match(/\/app\/accounts\/(\d+)\//)?.[1])) => accountAttentionEnabled(accountId);
export const personalUnreadCount = (id, legacy = 0) => attentionEnabled()
  ? attentionFor(id)?.personal_unseen_messages ?? attentionFor(id)?.unseen_messages ?? null : legacy;
export const personalMessageState = id => {
  const routeAccount = Number(window.location.pathname.match(/\/app\/accounts\/(\d+)\//)?.[1]);
  if (routeAccount && attentionState.snapshot?.account_id !== routeAccount) return undefined;
  return attentionState.snapshot?.message_states?.find(row => row.message_id === id);
};

export function canAutoScrollTranscript(panel, messageId, doc = document) {
  if (!panel || doc.visibilityState !== 'visible' || !doc.hasFocus()) return false;
  if ([...doc.querySelectorAll('[role="dialog"],[aria-modal="true"],.woot-modal')].some(dialog => dialog.getClientRects().length)) return false;
  return !!messageId || panel.scrollHeight - panel.scrollTop - panel.clientHeight <= 48;
}

export const countLabel = count => (Number(count) > 999 ? '999+' : String(Number(count) || 0));
export const waitingAge = (timestamp, now = Date.now()) => {
  if (!timestamp) return '';
  const seconds = Math.max(0, Math.floor((now - Date.parse(timestamp)) / 1000));
  if (!Number.isFinite(seconds)) return 'unknown';
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h`;
  return `${Math.floor(seconds / 86400)}d`;
};

export function messageIsPresented(element, doc = document) {
  if (!element || doc.visibilityState !== 'visible' || !doc.hasFocus()) return false;
  if ([...doc.querySelectorAll('[role="dialog"],[aria-modal="true"],.woot-modal')].some(dialog => dialog.getClientRects().length)) return false;
  const rect = element.getBoundingClientRect();
  if (rect.width < 1 || rect.height < 1) return false;
  let top = 0; let left = 0; let right = innerWidth; let bottom = innerHeight;
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    const style = getComputedStyle(parent);
    if (/(auto|scroll|hidden|clip)/.test(style.overflow + style.overflowY + style.overflowX)) {
      const bounds = parent.getBoundingClientRect();
      top = Math.max(top, bounds.top); left = Math.max(left, bounds.left);
      right = Math.min(right, bounds.right); bottom = Math.min(bottom, bounds.bottom);
    }
  }
  const visibleWidth = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
  const visibleHeight = Math.max(0, Math.min(rect.bottom, bottom) - Math.max(rect.top, top));
  if (visibleWidth * visibleHeight / (rect.width * rect.height) < 0.8) return false;
  const x = Math.max(left, rect.left) + visibleWidth / 2;
  const y = Math.max(top, rect.top) + visibleHeight / 2;
  const hit = doc.elementFromPoint(x, y);
  return hit === element || element.contains(hit);
}
